import {Component, Inject, OnInit} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {ToastrService} from 'ngx-toastr';
import {ViewUpdateTprApiService} from '../../../../../../modules/api/view-update-tpr-api.service';
import {UntypedFormControl, Validators} from '@angular/forms';
import {finalize} from 'rxjs/operators';

@Component({
    selector: 'tpr-duplicate-rev-dialog',
    templateUrl: './tpr-duplicate-rev-dialog.component.html',
    styleUrls: ['../../../tprecm.style.scss']
})
export class TprDuplicateRevDialogComponent implements OnInit {

    constructor(
        public readonly dialog: MatDialogRef<TprDuplicateRevDialogComponent>,
        private readonly toastr: ToastrService,
        private readonly viewUpdateTprApiService: ViewUpdateTprApiService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    loading = false;

    toolNo: string;
    selectedToolId: string;

    selectedRev: UntypedFormControl = new UntypedFormControl(null, Validators.required);

    revOpts: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    ngOnInit() {
        if (!(this.data.toolNo && this.data.selectedToolId)) {
            this.toastr.error('Please select a tool be be rev duplicated');
            return;
        }

        this.toolNo = this.data.toolNo;
        this.selectedToolId = this.data.selectedToolId;
    }

    duplicateTpr() {
        if (!this.selectedRev.valid) {
            return;
        }

        this.loading = true;

        this.viewUpdateTprApiService
            .duplicateRevTpr(`${this.toolNo.toUpperCase()}_${this.selectedRev.value}`, this.data.selectedToolId)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => this.dialog.close(response));
    }

}
